import Big, { BigSource } from 'big.js';

export const ConversionUtils = {
  fromCentsToDollars: (cents: BigSource) => new Big(cents).div(100).toNumber(),
  fromDollarsToCents: (dollars: BigSource) => new Big(dollars).mul(100).toNumber(),
  fromPercentToDecimal: (percent: BigSource) => new Big(percent).div(100).toNumber(),
  fromDecimalToPercent: (decimal: BigSource) => new Big(decimal).mul(100).toNumber(),
};
